const PICTURE_FORMATS = Object.freeze(['jpg', 'jpeg', 'png', 'webp'])
const VIDEO_FORMATS = Object.freeze([
    'mp4',
    'webm',
    'ogg',
    'mov',
    'avi',
    'wmv',
    'flv',
    'mkv',
])

/**
 * Checks if the given format is a picture format.
 * @param {string} format - The format to check.
 * @returns {boolean} - Returns true if the format is a picture format, otherwise false.
 */
export const getIsPicture = format => {
    if (!format) {
        return false
    }
    return !!PICTURE_FORMATS.find(standardFormat =>
        format.includes(standardFormat),
    )
}

/**
 * Checks if a given format is a video format.
 *
 * @param {string} format - The format to check.
 * @returns {boolean} - Returns true if the format is a video format, otherwise returns false.
 */
export const getIsVideo = format => {
    if (!format) {
        return false
    }
    return !!VIDEO_FORMATS.find(standardFormat =>
        format.includes(standardFormat),
    )
}

/**
 * Generates a thumbnail URL for a given picture URL with specified width and height.
 *
 * @param {string} url - The original picture URL.
 * @param {number} width - The desired width of the thumbnail.
 * @param {number} height - The desired height of the thumbnail.
 * @returns {string} The thumbnail URL.
 */
export const getPictureThumbnail = (url, width, height) => {
    if (!url) {
        return url
    }
    let thumbnailTransformation = 'c_thumb'
    if (width) {
        thumbnailTransformation += `,w_${width}`
    }
    if (height) {
        thumbnailTransformation += `,h_${height}`
    }
    const splitter = '/upload/'
    const splittedURL = url.split(splitter)
    if (splittedURL.length <= 1) {
        return url
    }
    const formatSplit = splittedURL[1].split('.')
    let format = formatSplit[1]
    if (!getIsPicture(format)) {
        format = 'png'
    }
    return `${splittedURL[0]}${splitter}${thumbnailTransformation}/${formatSplit[0]}.${format}`
}
